import { useState } from 'react';

import styled from 'styled-components';

import { RelativeSpinner } from '@components/loading-spinner';
import { XOR } from '@utils/types';

export type ImageViewerProps = { url?: string } & XOR<{ maxHeight: number }, { maxWidth: number }>;

export function ImageViewer({ url, maxHeight, maxWidth }: ImageViewerProps) {
  const [isLoading, setIsLoading] = useState(false);
  if (url === null) return null;

  return (
    <>
      {isLoading && <RelativeSpinner />}
      <ImageElement
        alt=""
        crossOrigin="anonymous"
        src={url}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        onLoad={() => setIsLoading(false)}
      />
    </>
  );
}

type FileProps = Omit<ImageViewerProps, 'url'>;

const ImageElement = styled.img<FileProps>(({ maxWidth, maxHeight }) =>
  maxHeight !== undefined
    ? { maxHeight, maxWidth: 'auto', objectFit: 'contain', alignSelf: 'flex-start' }
    : {
        maxWidth: `min(${maxWidth}px, 100%)`,
      },
);

export default ImageViewer;
